// react core
import { useContext } from "react";

// material design
import Box from "@mui/material/Box";

// fonts and icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoins } from "@fortawesome/pro-duotone-svg-icons";
import { faThumbTack as iconPin } from "@fortawesome/pro-duotone-svg-icons";
// icons for public and private access
import { faGlobe as iconPublic } from "@fortawesome/pro-duotone-svg-icons";
import { faLock as iconPrivate } from "@fortawesome/pro-duotone-svg-icons";
// icons for owner, manager, and rider
import { faCrown as iconOwner } from "@fortawesome/pro-duotone-svg-icons";
import { faUserTie as iconManager } from "@fortawesome/pro-duotone-svg-icons";
import { faUser as iconRider } from "@fortawesome/pro-duotone-svg-icons";

// entzy config and services
// import configEntzy from "components/config/ConfigEntzy";
// import { MainContext } from "components/main/MainContext";
import { EventContext } from "components/event/EventContext";

// entzy components
import { TextTag } from "components/utils/common/CommonTags";

function EventFrameTags(props) {
  // const mainContext = useContext(MainContext);
  const eventContext = useContext(EventContext);

  let event = props.event || {};
  event.pinned = props.pinned || false;
  event.owner = props.owner || false;
  event.manager = props.manager || false;
  if (eventContext?.state?.event?.hydrated) {
    event = eventContext.state.event.data;
    event.pinned = eventContext.state.event.pinned || false;
    event.owner = eventContext.state.event.owner || false;
    event.manager = eventContext.state.event.manager || false;
  }

  return (
    <Box className="box-default">
      {/* event country */}
      <TextTag
        text={event.Country}
        flag={event.Country}
        size="sm"
        bgColor="black"
        color="white"
        rounded={true}
        shadow={true}
        shadowDark={true}
      />

      {/* event currency */}
      <TextTag
        text={
          <span>
            <span>&nbsp;</span>
            {event.Currency}
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <FontAwesomeIcon icon={faCoins} />
          </span>
        }
        size="sm"
        bgColor="darkgreen"
        color="white"
        rounded={true}
      />

      {/* event access level */}
      {event.Access === "private" ? (
        <TextTag
          text={
            <span>
              <span>&nbsp;</span>
              {event.Access}
              <span>&nbsp;&nbsp;</span>
              <FontAwesomeIcon icon={iconPrivate} />
            </span>
          }
          size="sm"
          bgColor="darkred"
          color="white"
          rounded={true}
        />
      ) : (
        <TextTag
          text={
            <span>
              <span>&nbsp;</span>
              {event.Access}
              <span>&nbsp;&nbsp;&nbsp;</span>
              <FontAwesomeIcon icon={iconPublic} />
            </span>
          }
          size="sm"
          bgColor="purple"
          color="white"
          rounded={true}
        />
      )}

      {/* event relationship tag */}
      {event.owner ? (
        <TextTag
          text={
            <span>
              <span>&nbsp;</span>
              <span>owner</span>
              <span>&nbsp;&nbsp;</span>
              <FontAwesomeIcon icon={iconOwner} />
            </span>
          }
          size="sm"
          bgColor="darkblue"
          color="white"
          rounded={true}
          shadow={true}
        />
      ) : event.manager ? (
        <TextTag
          text={
            <span>
              <span>&nbsp;</span>
              <span>manager</span>
              <span>&nbsp;</span>
              <FontAwesomeIcon icon={iconManager} />
            </span>
          }
          size="sm"
          bgColor="darkslateblue"
          color="white"
          rounded={true}
          shadow={true}
        />
      ) : (
        <TextTag
          text={
            <span>
              <span>&nbsp;</span>
              <span>rider</span>
              <span>&nbsp;&nbsp;</span>
              {event.pinned ? (
                <FontAwesomeIcon icon={iconPin} transform="rotate-45" />
              ) : (
                <FontAwesomeIcon icon={iconRider} />
              )}
            </span>
          }
          size="sm"
          bgColor={event.pinned ? "dodgerblue" : "black"}
          color="white"
          rounded={true}
          shadow={true}
        />
      )}
    </Box>
  );
}

export default EventFrameTags;
